import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "backgroundsSpritesheets/tablet/14_beach/14_beach"
 * Contains 1 texture(s)
 */
export class Tablet14BeachAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'backgroundsSpritesheets/tablet/14_beach/14_beach';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '14_beach.jpg'
    ] as const;
}
